module.exports = __webpack_public_path__ + "4ee5ac07258726ec920014d3090128a8.jpg";